import apiClient from '../connections/api'

const getSiteById = (_id) => {
    return apiClient.get(`/sites/${_id}`)
}
const getSites = () => {
    return apiClient.get('/sites')
}
const getHiddenSites = () => {
    return apiClient.get('/sites/hidden-sites')
}

const migrateAllContent = (fromSiteId, toSiteId) => {
    return apiClient.post('/sites/migrate-all-content', { fromSiteId, toSiteId })
}

export default {
    getSiteById,
    getSites,
    getHiddenSites,
    migrateAllContent
}
